module.exports = __webpack_public_path__ + "@/assets/img/bot6.3de2e1f8.png";